import { render, staticRenderFns } from "./DivEditable.vue?vue&type=template&id=baf3098a&scoped=true"
import script from "./DivEditable.vue?vue&type=script&lang=js"
export * from "./DivEditable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf3098a",
  null
  
)

export default component.exports